module.exports = __webpack_public_path__ + "static/media/redHat.35d64056.png";